import { ArrowRight, Building2, MessageCircle, Sparkles, UserRound } from 'lucide-react'
import { InteractiveJourney } from '../../components/how/InteractiveJourney'
import { ButtonLink } from '../../components/ui/Button'

export function HowItWorksPage() {
  return <main className="how-page-v4">
    <section className="section container how-page-v4__hero">
      <span className="eyebrow">Comment ça marche</span>
      <h1>Comprendre la plateforme en quelques clics</h1>
      <p>Choisissez votre point de vue, parcourez les étapes et découvrez ce qui se passe à chaque moment de la relation.</p>
      <div className="how-page-v4__chips"><span><Building2 size={16} />Parcours entreprise</span><span><UserRound size={16} />Parcours athlète</span><span><MessageCircle size={16} />Conversation au centre</span></div>
    </section>
    <section className="section container"><InteractiveJourney pageMode /></section>
    <section className="section container how-page-v4__cta"><div><Sparkles /><span><strong>Prêt à tester le parcours ?</strong><small>Les comptes de démonstration donnent accès aux deux espaces.</small></span></div><div><ButtonLink to="/athletes" variant="ghost">Découvrir les athlètes</ButtonLink><ButtonLink to="/inscription">Créer un compte <ArrowRight size={17} /></ButtonLink></div></section>
  </main>
}
